import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { IoClose } from "react-icons/io5";
import "../css/AdminApplications.css";

const AdminApplications = () => {
  const [activeTab, setActiveTab] = useState("jobs");

  const [applications, setApplications] = useState([]);
  const [admissions, setAdmissions] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [scholarships, setScholarships] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedAdmission, setSelectedAdmission] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedScholarship, setSelectedScholarship] = useState(null);

  useEffect(() => {
    const qJobs = query(
      collection(db, "applications"),
      orderBy("appliedAt", "desc"),
    );
    const unsubJobs = onSnapshot(qJobs, (snapshot) => {
      setApplications(
        snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      );
    });

    const qAdmissions = query(
      collection(db, "admissions"),
      orderBy("submittedAt", "desc"),
    );
    const unsubAdmissions = onSnapshot(qAdmissions, (snapshot) => {
      setAdmissions(
        snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      );
    });

    const qContacts = query(
      collection(db, "contacts"),
      orderBy("submittedAt", "desc"),
    );
    const unsubContacts = onSnapshot(qContacts, (snapshot) => {
      setContacts(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    const qScholarships = query(
      collection(db, "scholarships"),
      orderBy("appliedAt", "desc"),
    );
    const unsubScholarships = onSnapshot(qScholarships, (snapshot) => {
      setScholarships(
        snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      );
      setLoading(false);
    });

    return () => {
      unsubJobs();
      unsubAdmissions();
      unsubContacts();
      unsubScholarships();
    };
  }, []);

  return (
    <div className="admin-dashboard">
      <div className="admin-header-flex">
        <h2>📋 School Management Dashboard</h2>

        {}
        <div
          className="admin-tabs-container"
          style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
        >
          <button
            className={`tab-btn ${activeTab === "jobs" ? "active-tab" : ""}`}
            onClick={() => setActiveTab("jobs")}
          >
            Jobs ({applications.length})
          </button>
          <button
            className={`tab-btn ${activeTab === "admissions" ? "active-tab" : ""}`}
            onClick={() => setActiveTab("admissions")}
          >
            Admissions ({admissions.length})
          </button>
          <button
            className={`tab-btn ${activeTab === "contacts" ? "active-tab" : ""}`}
            onClick={() => setActiveTab("contacts")}
          >
            Enquiries ({contacts.length})
          </button>
          <button
            className={`tab-btn ${activeTab === "scholarships" ? "active-tab" : ""}`}
            onClick={() => setActiveTab("scholarships")}
            style={{
              backgroundColor: activeTab === "scholarships" ? "#f59e0b" : "",
            }}
          >
            Scholarships ({scholarships.length})
          </button>
        </div>
      </div>

      {loading ? (
        <p className="loading-text">Fetching Live Database Records...</p>
      ) : (
        <div className="table-responsive">
          {}
          {activeTab === "jobs" && (
            <table className="app-table">
              <thead>
                <tr>
                  <th>Applicant Name</th>
                  <th>Applied Position</th>
                  <th>Qualification</th>
                  <th>Experience</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {applications.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No applications data.
                    </td>
                  </tr>
                ) : (
                  applications.map((app) => (
                    <tr key={app.id}>
                      <td>
                        <strong>{app.fullName}</strong>
                      </td>
                      <td>
                        <span className="pos-tag">{app.jobTitle}</span>
                      </td>
                      <td>{app.qualification}</td>
                      <td>{app.experience} Years</td>
                      <td>
                        <button
                          className="view-btn"
                          onClick={() => setSelectedApp(app)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}

          {}
          {activeTab === "admissions" && (
            <table className="app-table">
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Applying Grade</th>
                  <th>Parent Name</th>
                  <th>Phone Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {admissions.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No admission inquiries data.
                    </td>
                  </tr>
                ) : (
                  admissions.map((adm) => (
                    <tr key={adm.id}>
                      <td>
                        <strong>{adm.studentName}</strong>
                      </td>
                      <td>
                        <span className="grade-tag">{adm.grade}</span>
                      </td>
                      <td>{adm.parentName}</td>
                      <td>{adm.phone}</td>
                      <td>
                        <button
                          className="view-btn adm-color-btn"
                          onClick={() => setSelectedAdmission(adm)}
                        >
                          View Request
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}

          {}
          {activeTab === "contacts" && (
            <table className="app-table">
              <thead>
                <tr>
                  <th>Sender Name</th>
                  <th>Email</th>
                  <th>Subject Topic</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {contacts.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No contact enquiries received yet.
                    </td>
                  </tr>
                ) : (
                  contacts.map((con) => (
                    <tr key={con.id}>
                      <td>
                        <strong>{con.name}</strong>
                      </td>
                      <td>{con.email}</td>
                      <td>
                        <span className="contact-subject-tag">
                          {con.subject}
                        </span>
                      </td>
                      <td>
                        <button
                          className="view-btn contact-color-btn"
                          onClick={() => setSelectedContact(con)}
                        >
                          View Msg
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}

          {}
          {activeTab === "scholarships" && (
            <table className="app-table">
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Scheme Program</th>
                  <th>Grade</th>
                  <th>City / Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {scholarships.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No scholarship entries in database.
                    </td>
                  </tr>
                ) : (
                  scholarships.map((sch) => (
                    <tr key={sch.id}>
                      <td>
                        <strong>{sch.applicantName}</strong>
                      </td>
                      <td>
                        <span
                          className="pos-tag"
                          style={{
                            backgroundColor: "#fffbeb",
                            color: "#b45309",
                            border: "1px solid #fde68a",
                          }}
                        >
                          {sch.scholarshipType}
                        </span>
                      </td>
                      <td>{sch.currentGrade}</td>
                      <td>{sch.studentAddress}</td>
                      <td>
                        <button
                          className="view-btn"
                          style={{ backgroundColor: "#d97706" }}
                          onClick={() => setSelectedScholarship(sch)}
                        >
                          Review App
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      )}

      {}
      {selectedApp && (
        <div className="form-modal-overlay">
          <div className="form-modal-card details-card">
            <div className="form-modal-header">
              <div>
                <h2>Applicant Profile</h2>
                <p className="job-badge">{selectedApp.jobTitle}</p>
              </div>
              <button
                className="form-close-btn"
                onClick={() => setSelectedApp(null)}
              >
                <IoClose />
              </button>
            </div>
            <div className="details-body">
              <p>
                <strong>Full Name:</strong> {selectedApp.fullName}
              </p>
              <p>
                <strong>Email:</strong> {selectedApp.email}
              </p>
              <p>
                <strong>Phone:</strong> {selectedApp.phone}
              </p>
              <p>
                <strong>Highest Qualification:</strong>{" "}
                {selectedApp.qualification}
              </p>
              <p>
                <strong>Total Experience:</strong> {selectedApp.experience}{" "}
                Years
              </p>
              <p>
                <strong>Resume:</strong>{" "}
                <a
                  href={selectedApp.resumeUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="resume-link"
                >
                  Open Resume File ↗
                </a>
              </p>
              <div className="cover-letter-box">
                <strong>Cover Letter:</strong>
                <p>{selectedApp.coverLetter || "No message."}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {}
      {selectedAdmission && (
        <div className="form-modal-overlay">
          <div className="form-modal-card details-card">
            <div className="form-modal-header">
              <div>
                <h2>Admission Inquiry</h2>
                <p className="job-badge grade-badge">
                  {selectedAdmission.grade}
                </p>
              </div>
              <button
                className="form-close-btn"
                onClick={() => setSelectedAdmission(null)}
              >
                <IoClose />
              </button>
            </div>
            <div className="details-body">
              <p>
                <strong>Student Name:</strong> {selectedAdmission.studentName}
              </p>
              <p>
                <strong>Grade:</strong> {selectedAdmission.grade}
              </p>
              <p>
                <strong>Parent Name:</strong> {selectedAdmission.parentName}
              </p>
              <p>
                <strong>Phone:</strong> {selectedAdmission.phone}
              </p>
              <div className="cover-letter-box">
                <strong>Remarks:</strong>
                <p>{selectedAdmission.message || "No remarks."}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {}
      {selectedContact && (
        <div className="form-modal-overlay">
          <div className="form-modal-card details-card">
            <div className="form-modal-header">
              <div>
                <h2>General Message</h2>
                <p className="job-badge contact-badge">
                  {selectedContact.subject}
                </p>
              </div>
              <button
                className="form-close-btn"
                onClick={() => setSelectedContact(null)}
              >
                <IoClose />
              </button>
            </div>
            <div className="details-body">
              <p>
                <strong>Sender Name:</strong> {selectedContact.name}
              </p>
              <p>
                <strong>Email Address:</strong> {selectedContact.email}
              </p>
              <p>
                <strong>Subject Topic:</strong> {selectedContact.subject}
              </p>
              <div className="cover-letter-box">
                <strong>Message Content:</strong>
                <p style={{ whiteSpace: "pre-line" }}>
                  {selectedContact.message}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {}
      {selectedScholarship && (
        <div className="form-modal-overlay">
          <div className="form-modal-card details-card">
            <div className="form-modal-header">
              <div>
                <h2>Scholarship Profile File</h2>
                <p
                  className="job-badge"
                  style={{ backgroundColor: "#fef3c7", color: "#92400e" }}
                >
                  {selectedScholarship.scholarshipType}
                </p>
              </div>
              <button
                className="form-close-btn"
                onClick={() => setSelectedScholarship(null)}
              >
                <IoClose />
              </button>
            </div>
            <div className="details-body">
              <p>
                <strong>Candidate Name:</strong>{" "}
                {selectedScholarship.applicantName}
              </p>
              <p>
                <strong>Email Link:</strong> {selectedScholarship.email}
              </p>
              <p>
                <strong>Phone Number:</strong> {selectedScholarship.phone}
              </p>
              <p>
                <strong>Target Grade Class:</strong>{" "}
                {selectedScholarship.currentGrade}
              </p>
              <p>
                <strong>Registered Student Address:</strong>{" "}
                {selectedScholarship.studentAddress}
              </p>
              <div className="cover-letter-box">
                <strong>Achievements & Remarks Statement:</strong>
                <p style={{ whiteSpace: "pre-line", color: "#374151" }}>
                  {selectedScholarship.achievements}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminApplications;
